/** Raw row from GET .../getModels */
export interface IBidderModelApi {
	campaigns?: string;
	last_successful_build?: string;
	model_name: string;
	real_advertiser_id?: number;
	should_build?: boolean;
	status?: string;
}

export interface IGetBidderModelsResponse {
	success?: boolean;
	models: IBidderModelApi[];
	MetaData?: Record<string, unknown>;
}

/** Payload for update (snake_case to match typical bidder admin API) */
export interface IBidderModelUpdatePayload {
	model_name: string;
	should_build?: boolean;
	status?: string;
}

export class BidderModelTableModel {
	campaigns: string;
	lastSuccessfulBuild: string;
	modelName: string;
	realAdvertiserId: number;
	shouldBuild: boolean;
	status: string;

	constructor(data: IBidderModelApi) {
		this.campaigns = data.campaigns ?? '';
		this.lastSuccessfulBuild = data.last_successful_build ?? '';
		this.modelName = data.model_name ?? '';
		this.realAdvertiserId = data.real_advertiser_id ?? 0;
		this.shouldBuild = Boolean(data.should_build);
		this.status = data.status ?? '';
	}

	toApi(): IBidderModelApi {
		return {
			model_name: this.modelName,
			campaigns: this.campaigns,
			last_successful_build: this.lastSuccessfulBuild,
			real_advertiser_id: this.realAdvertiserId,
			should_build: this.shouldBuild,
			status: this.status,
		};
	}

	toUpdatePayload(): IBidderModelUpdatePayload {
		return {
			model_name: this.modelName,
			should_build: this.shouldBuild,
			status: this.status,
		};
	}
}
